export default function PoolTypesElPaso() {
  const poolTypes = [
    {
      name: 'Gunite Pools',
      description: 'The most popular choice in El Paso, gunite pools offer unlimited design flexibility and exceptional durability. Custom shapes, depths, and features make each pool unique.',
      bestFor: 'Custom designs, permanent installations, luxury features',
      image: 'https://public.readdy.ai/ai/img_res/fa429f2733b786d5642f7d20e97603dc.jpg'
    },
    {
      name: 'Fiberglass Pools',
      description: 'Quick installation and low maintenance make fiberglass pools ideal for El Paso homeowners. Smooth surface resists algae and requires fewer chemicals.',
      bestFor: 'Fast installation, low maintenance, smooth surface',
      image: 'https://readdy.ai/api/search-image?query=Modern%20fiberglass%20swimming%20pool%20with%20sleek%20design%2C%20smooth%20gel%20coat%20finish%20in%20vibrant%20blue%20color%2C%20contemporary%20rectangular%20pool%20with%20built-in%20steps%20and%20bench%20seating%2C%20professional%20fiberglass%20pool%20installation%20in%20clean%20backyard%20with%20minimal%20landscaping%20and%20desert%20plants&width=600&height=400&seq=pool-type-002&orientation=landscape'
    },
    {
      name: 'Infinity Edge Pools',
      description: 'Create a stunning visual effect with infinity edge pools that blend seamlessly with El Paso\'s mountain views. Perfect for hillside properties and modern designs.',
      bestFor: 'Scenic views, modern aesthetics, luxury properties',
      image: 'https://readdy.ai/api/search-image?query=Spectacular%20infinity%20edge%20swimming%20pool%20overlooking%20mountains%2C%20vanishing%20edge%20pool%20with%20seamless%20water%20overflow%2C%20luxury%20resort-style%20pool%20with%20stunning%20panoramic%20views%2C%20modern%20infinity%20pool%20design%20showcasing%20architectural%20excellence%20with%20dramatic%20edge%20detail%20and%20breathtaking%20desert%20landscape%20vista&width=600&height=400&seq=pool-type-003&orientation=landscape'
    },
    {
      name: 'Natural Pools',
      description: 'Eco-friendly natural pools use plants and biological filters instead of chemicals. Rock formations and natural materials create a lagoon-like atmosphere.',
      bestFor: 'Eco-conscious homeowners, natural aesthetics, chemical-free',
      image: 'https://readdy.ai/api/search-image?query=Natural%20swimming%20pool%20with%20organic%20rock%20formations%2C%20eco-friendly%20pool%20with%20natural%20stone%20edges%20and%20aquatic%20plants%2C%20lagoon-style%20pool%20blending%20with%20landscape%2C%20chemical-free%20natural%20pool%20design%20featuring%20boulders%20waterfalls%20and%20lush%20vegetation%20creating%20serene%20backyard%20oasis%20environment&width=600&height=400&seq=pool-type-004&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pool Types for El Paso Homes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore different pool styles and construction methods to find the perfect fit for your backyard and lifestyle
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {poolTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={type.image}
                  alt={type.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {type.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <div className="flex items-start gap-2 bg-teal-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Best For:</strong>
                    <p className="text-gray-700 text-sm">{type.bestFor}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
